module.exports = __webpack_public_path__ + "static/img/cnbookinglog.6a792d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cnbookinglog.png
// module id = 7BU3
// module chunks = 1